import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"item-text":_vm.countryName,"item-value":c=>c.alpha2Code,"items":_vm.countries,"loading":_vm.loading,"rules":_vm.rules,"label":_vm.label},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})
}
var staticRenderFns = []

export { render, staticRenderFns }